export const departmentsPtBr = {
  common: {
    loading: 'Carregando...',
    save: 'Salvar',
    saving: 'Salvando...',
    cancel: 'Cancelar',
    edit: 'Editar',
    delete: 'Excluir',
    search: 'Pesquisar',
    noResults: 'Nenhum departamento encontrado.',
    change: 'Alterar',
    select: 'Selecionar',
  },
  errors: {
    loadDepartments: 'Erro ao carregar departamentos',
    loadCostCenters: 'Erro ao carregar centros de custo vinculados',
    saveDepartment: 'Erro ao salvar departamento',
    linkCostCenters: 'Erro ao vincular centros de custo',
    unlinkCostCenters: 'Erro ao desvincular centros de custo',
    parentSameEntity: 'O departamento pai deve pertencer à mesma entidade do departamento filho',
    loadUsers: 'Erro ao carregar usuários',
  },
  success: {
    departmentCreated: 'Departamento criado com sucesso',
    departmentUpdated: 'Departamento atualizado com sucesso',
    departmentDeleted: 'Departamento excluído com sucesso',
  },
  pages: {
    departments: {
      title: 'Departamentos',
      createButton: 'Novo Departamento',
      integrationMapping: 'Mapeamento de integrações',
      searchPlaceholder: 'Buscar departamentos...',
      filters: {
        entity: {
          all: 'Todas entidades',
        },
        status: {
          label: 'Status',
          all: 'Todos',
          active: 'Ativos',
        },
      },
      stats: {
        departments: 'departamentos',
        subDepartments: 'subdepartamentos',
      },
      viewToggle: {
        expand: 'Expandir',
        collapse: 'Esconder',
      },
    },
  },
  form: {
    title: {
      create: 'Novo Departamento',
      edit: 'Editar Departamento',
    },
    description: 'Configure os detalhes do departamento.',
    sections: {
      basicInfo: {
        title: 'Informações Básicas',
        fields: {
          name: {
            label: 'Nome do Departamento',
            placeholder: 'Ex: Financeiro',
          },
          parent: {
            label: 'Departamento Pai',
            placeholder: 'Nenhum (departamento raiz)',
          },
          description: {
            label: 'Descrição',
            placeholder: 'Descrição do departamento...',
          },
        },
      },
      head: {
        title: 'Responsável do Departamento',
        subtitle: 'Usuário que aprova gastos',
        fields: {
          headUser: {
            label: 'Responsável do Departamento',
            placeholder: 'Selecione um usuário',
            noHead: 'Nenhum responsável definido',
          },
        },
      },
      limits: {
        title: 'Limite de Aprovação',
        subtitle: 'Valor máximo que o responsável pode aprovar',
        fields: {
          transactionLimit: {
            label: 'Limite por Transação',
            suffix: '/ transação',
            placeholder: '0,00',
          },
          monthlyLimit: {
            label: 'Limite Mensal',
            suffix: '/ mês',
            placeholder: 'Sem limite',
            noLimit: 'Sem limite',
          },
          warning: {
            transactionExceedsMonthly:
              'O limite por transação não pode ser maior que o limite mensal.',
          },
        },
      },
      costCenters: {
        title: 'Centros de Custo Vinculados',
        loading: 'Carregando centros de custo vinculados...',
        empty: 'Nenhum centro de custo vinculado',
        inherited: 'Herdado',
        inheritedHelp: 'Centros de custo herdados do departamento pai não podem ser removidos.',
      },
      payrollGl: {
        title: 'Conta GL (folha)',
        subtitle: 'Conta contábil para lançamento da folha por departamento',
        placeholder: 'Selecione a conta raiz',
        linkToMapping: 'Também em Folha → Mapeamento CC/Depto',
      },
      aiContext: {
        title: 'Contexto para IA',
        subtitle: 'Opcional',
        placeholder: 'Informações contextuais para categorização e sugestões inteligentes...',
        generating: 'Gerando sugestão com IA...',
        regenerate: 'Gerar novamente',
        classificationContext: 'Contexto de Classificação',
      },
    },
  },
  detail: {
    subDepartments: 'Sub-deptos',
    costCenters: 'Centros Custo',
    approvalLimit: 'Limite Aprovação',
    rootDepartment: 'Departamento raiz',
  },
  selector: {
    headUser: {
      label: 'Responsável do Departamento',
      placeholder: 'Selecione um usuário',
      searchPlaceholder: 'Buscar por nome ou email...',
      noResults: 'Nenhum usuário encontrado.',
    },
  },
};
